/**
 * (신규) 근태 Approval 양식별 사용 가능 법인 코드 (F&F=A, 홀딩스=HC, F&CO=N, W&W=W).
 * 매핑에 없는 양식은 전 법인 허용, 미허용 법인은 양식 진입 차단 + 알럿.
 * 데스크탑(CreateApprovalModal)·모바일(ApprovalWirte) 공통 규칙.
 */
export const ATTENDANCE_APPROVAL_COMPANY_CODES: Record<number, string[]> = {
  222: ['A', 'HC', 'N'], // (신규)근무시간 변경
  223: ['A', 'HC'], // (신규)연장근무 신청
  224: ['A', 'HC'], // (신규)연장근무 적립 사용
  // (신규)연차 — 국내 법인 전체. W&W(W) 는 F&CO 자회사라 F&CO(N) 와 같게 허용 (PORTAL-14903)
  231: ['A', 'HC', 'N', 'FL', 'D', 'FE', 'W'],
};

/** 근태 양식 → Portal 모달로 처리하는 apv_type 목록 (iframe 이동 대신 모달) */
export const ATTENDANCE_MODAL_APPROVAL_TYPES = [222, 223, 224, 231];

/** 해당 법인이 해당 근태 양식을 사용할 수 있는지 여부. 매핑이 없으면 전 법인 허용. */
export const isAttendanceApprovalCompanyAllowed = (
  type: number,
  companyCode: string,
) => {
  const allowedCompanyCodes = ATTENDANCE_APPROVAL_COMPANY_CODES[type];
  return !allowedCompanyCodes || allowedCompanyCodes.includes(companyCode);
};
